export default {
    init() {

        // const svgPlaying = 'icon--speaker-playing';
        // const svgStopped = 'icon--speaker';

        (Array.from(document.querySelectorAll('.person__pronunciation')) ?? [])
            .forEach(el => {
                const player = el.querySelector('.pronunciation__player');
                const playBtn = el.querySelector('.control-playback-toggle');

                playBtn.addEventListener('click', e => {
                    // Toggle playing class on audio element
                    player.classList.toggle('playing', player.paused);

                    if (player.paused) {
                        // Play audio from the beginning
                        player.currentTime = 0;
                        player.play();

                        // Set icon to playing
                        playBtn.innerHTML = '<svg class="icon icon-speaker">' +
                                                '<use xlink:href="#icon--speaker-playing"></use>' +
                                            '</svg>' +
                                            '<span class="sr-only">Toggle Playback</span>';
                    } else {
                        // Stop playback of the audio
                        player.pause();

                        // Set icon to stopped
                        playBtn.innerHTML = '<svg class="icon icon-speaker">' +
                                                '<use xlink:href="#icon--speaker"></use>' +
                                            '</svg>' +
                                            '<span class="sr-only">Toggle Playback</span>';
                    }
                });
            });
    }
}
